<template>
  <v-text-field
    :label="label"
    color="#F0AF67"
    v-model="inputData"
    solo
    flat
    background-color="rgba(255,255,255,0.3)"
    dark
    hide-details="true"
    height="44px"
    class="form"
    v-if="formShow"
    :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
    :type="showPass ? 'text' : 'password'"
    @click:append="showPass = !showPass"
  ></v-text-field>
</template>

<script>
export default {
  name: "PassTextField",
  data: () => ({
    showPass: false
  }),
  methods: {
  },
  computed:{
    inputData: {
      get () {
        return this.formData
      },
      set (value) {
        this.$emit('update:formData', value)
      }
    },
  },
  props:['label','formShow', 'formData']
};
</script>

<style scoped>
.form {
  border-radius: 12px;
}
@media screen and (max-width: 350px) {
}
@media screen and (min-width: 351px) and (max-width: 768px) {
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
@media screen and (min-width: 1024px) {
}
</style>
